import { render, staticRenderFns } from "./VButtonFile.vue?vue&type=template&id=710f08de&"
import script from "./VButtonFile.vue?vue&type=script&lang=js&"
export * from "./VButtonFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports